import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-sm-12 col-xl-6" }
const _hoisted_3 = { class: "form-card h-100 p-4" }
const _hoisted_4 = { class: "mb-3" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[3] || (_cache[3] = _createElementVNode("label", {
            for: "formFile",
            class: "form-label"
          }, "Upload File", -1)),
          _createElementVNode("input", {
            class: "form-control",
            type: "file",
            id: "formFile",
            onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($options.handleFileUpload && $options.handleFileUpload(...args)))
          }, null, 32)
        ]),
        _createElementVNode("button", {
          type: "submit",
          class: "btn btn-primary",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($options.uploadFile && $options.uploadFile(...args)))
        }, "Upload"),
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-success m-2",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($options.importData && $options.importData(...args))),
          disabled: !$data.dataRead
        }, "Import", 8, _hoisted_5),
        ($data.resultsAvailable)
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              class: "btn btn-warning m-2",
              href: $data.resultsUrl,
              download: ""
            }, "Download Results", 8, _hoisted_6))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}